import TOASTER_DATA from "../../components/shared/toaster/constants";
import {
  SOLACE_PUBLISH_EVENTS_SUCCESS,
  SOLACE_PUBLISH_EVENTS_FAILURE,
} from "../actions/publishSolaceEventActions";
import {
  SOLACE_CONSUME_EVENTS_SUCCESS,
  SOLACE_CONSUME_EVENTS_FAILURE,
} from "../actions/consumeSolaceEventsActions";

export const toasterReducer = (
  state: string = "",
  action: any
): string | any => {
  switch (action.type) {
    case "CONNECTED":
      return {
        message: "Successfully connected to solace router",
        type: "success",
      };
	case "DISCONNECTED" :
		return {
			message: `Connection failed to the Solace message router - check correct parameter values and connectivity!`,
			type: 'error',
		  };
    case SOLACE_PUBLISH_EVENTS_SUCCESS:
      return {
        message: action.payload.message,
        type: "success",
      };
    case SOLACE_PUBLISH_EVENTS_FAILURE:
      return {
        message: action.payload.message,
        type: "error",
      };
    case SOLACE_CONSUME_EVENTS_SUCCESS:
      return {
        message: action.payload.message,
        type: "success",
      };
    case SOLACE_CONSUME_EVENTS_FAILURE:
      return {
        message: action.payload.message,
        type: "error",
      };
    default:
      return state;
  }
};
